import cn from 'classnames';
import { ComponentProps, ReactElement, cloneElement, forwardRef } from 'react';

// to be deprecated

interface PortalInputProps extends ComponentProps<'input'> {
    label?: string;
    className?: string;
    containerClassName?: string;
    children: ReactElement;
    hasTooltipIcon?: boolean;
    value: any;
    onChange?: (value: any) => void;
}

const PortalInput = forwardRef<HTMLInputElement, PortalInputProps>((props, ref) => {
    const {
        name,
        label,
        children,
        hasTooltipIcon = false,
        onChange,
        onBlur,
        value,
        containerClassName,
        ...rest
    } = props;
    const { required, disabled } = rest;

    return (
        <div className={cn('flex flex-col gap-1 text-brand-text w-full', containerClassName)}>
            {label ? (
                <label
                    className={cn('relative text-xs', {
                        'w-[calc(100%-20px)]': hasTooltipIcon
                    })}>
                    {label}
                    {required && <span className="absolute -top-1 -right-1.5">*</span>}
                </label>
            ) : null}
            <div className="w-full">
                {cloneElement(children, {
                    ref,
                    onChange,
                    onBlur,
                    label,
                    name,
                    value,
                    selected: value,
                    className: {
                        'text-brand-neutral-400 cursor-not-allowed': disabled,
                        '': !disabled
                    },
                    ...rest
                })}
            </div>
        </div>
    );
});

PortalInput.displayName = 'PortalInput';

export default PortalInput;
